import { eventWithTime } from '@rrweb/types';
import * as pako from 'pako';
import * as _rrweb from 'rrweb';

const CUSTOM_EVENT_MAX_SIZE = 100;

let events: eventWithTime[] = [];
let seq = 1;
let intervalId: ReturnType<typeof setTimeout>;

declare global {
  interface Window {
    rrweb: typeof _rrweb;
  }
}

type CustomEvent = {
  target: { ariaLabel: string };
};

if (!window.rrweb) {
  window.rrweb = _rrweb;
}
const { rrweb } = window;

export const addEvent = (event: Event | CustomEvent) => {
  try {
    const { ariaLabel, textContent } = event.target as HTMLElement;
    const customEvent = ariaLabel || textContent?.trim();
    if (customEvent !== undefined && customEvent !== '') {
      rrweb.record.addCustomEvent(
        // サロゲートペア対策
        Array.from(customEvent.slice(0, CUSTOM_EVENT_MAX_SIZE * 2)) // UTF-16 単位で余裕を持って切り詰めておく（1 コードポイント = 最大 2 単位）
          .slice(0, CUSTOM_EVENT_MAX_SIZE)
          .join(''),
        null
      );
    }
  } catch {
    // NOTE: 機能に影響を与えないようにエラーを握りつぶす
  }
};

export const startRecord = () => {
  if (!document.head.querySelector('[name=t]')) return;

  document.addEventListener('click', addEvent);

  rrweb.record({
    emit(event) {
      events.push(event);
    },
  });

  const compressedEvents = () => {
    const json = JSON.stringify(events);
    const deflated = pako.deflate(json);

    return btoa(
      deflated.reduce((data, byte) => data + String.fromCharCode(byte), '')
    );
  };

  const save = () => {
    const requestId = (
      document.head.querySelector('[name=request_id]') as HTMLMetaElement
    ).content;
    const token = (
      document.body.querySelector('div[id=application]') as HTMLElement
    )?.dataset?.token;

    fetch('/t', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        events: compressedEvents(),
        path: window.location.pathname,
        request_id: requestId,
        seq,
        token,
      }),
    })
      .then((res) => {
        if (![200, 201].includes(res.status)) {
          clearInterval(intervalId);
        }
      })
      .catch(() => {
        // NOTE: 機能に影響を与えないようにエラーを握りつぶす
        clearInterval(intervalId);
      });

    events = [];
    seq += 1;
  };

  intervalId = setInterval(save, 5 * 1000);
};
